import { render, staticRenderFns } from "./ArenaVehicles2001.vue?vue&type=template&id=266154e3"
import script from "./ArenaVehicles2001.vue?vue&type=script&lang=js"
export * from "./ArenaVehicles2001.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports